module.exports = __webpack_public_path__ + "img/hoiwa_logo.55125d68.png";